import React, { Fragment, useEffect, useState } from 'reactn';
import {
	Typography,
	Box,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	Chip,
	SelectText,
	Autocomplete,
	TextField
} from 'components';

import { ChangeEvent } from 'react';
import { apiFetch } from 'meta/util';

const str = 'WTF'.repeat(20);
const tags = [
	'All',
	'Minion',
	'Skilling',
	'PvM',
	'Minigame',
	'Settings',
	'Patron',
	'Utility',
	'Simulation',
	'Fun'
];

const Commands: React.FC = () => {
	const [commands, setCommands] = useState<any>(null);

	const [flag, setFlag] = useState<string>(tags[0]);
	const [query, setQuery] = useState('');

	useEffect(() => {
		async function fetchCommands() {
			const res = await apiFetch({ path: '/commands' });
			setCommands(res);
		}
		fetchCommands();
	}, []);

	if (!commands) return null;

	return (
		<Fragment>
			<Typography variant="h2" component="h1">
				Commands
			</Typography>
			<Typography color="textSecondary" variant="subtitle1" gutterBottom>
				Here you can see a list of all the commands for Old School Bot.
			</Typography>
			<br />
			<Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
				<Box display="flex" alignItems="flex-start">
					<Box display="flex" alignItems="center" justifyContent="space-around">
						<Autocomplete
							id="tag-select"
							color="secondary"
							style={{ width: 300, marginRight: 20 }}
							options={tags}
							autoHighlight
							renderOption={(tag: string) => (
								<React.Fragment>
									<span>{tag}</span>
								</React.Fragment>
							)}
							value={flag}
							onChange={(_event: ChangeEvent<{}>, tag: string | null) => {
								if (tag) {
									setFlag(tag);
								}
							}}
							renderInput={(params) => (
								<TextField
									{...params}
									color="secondary"
									label="Command Categories"
									variant="outlined"
									inputProps={{
										...params.inputProps,
										autoComplete: 'new-password' // disable autocomplete and autofill
									}}
								/>
							)}
						/>
						<Box minWidth="300px">
							<SelectText
								autoFocus
								onChange={(e) => setQuery(e.target.value)}
								value={query}
								id="search"
								label="Search"
							/>
						</Box>
					</Box>

					<Table style={{ minWidth: 900 }}>
						<TableHead>
							<TableRow>
								<TableCell>Command</TableCell>
								<TableCell>Description</TableCell>
								<TableCell>Examples</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{commands
								.filter((cmd: any) => {
									if (query !== '') {
										return [cmd.name, cmd.desc].some((text) =>
											text?.toLowerCase().includes(query)
										);
									}
									return (
										flag === 'All' || cmd.flags?.includes(flag.toLowerCase())
									);
								})
								.map((cmd: any) => (
									<TableRow key={cmd.name}>
										<TableCell>
											<Box
												display="flex"
												flexDirection="column"
												justifyContent="space-around"
											>
												+{cmd.name}
												<br />
												<br />
												{cmd.permissionLevel === 6 && (
													<Chip
														label="Server Staff Only"
														variant="outlined"
													/>
												)}
												{cmd.permissionLevel === 7 && (
													<Chip
														label="Server Admins Only"
														variant="outlined"
													/>
												)}
												{cmd.perkTier && cmd.perkTier > 0 && (
													<Chip
														label={
															cmd.perkTier === 1
																? 'Nitro Boosters Only'
																: `Tier ${
																		cmd.perkTier - 1
																  } Patron Only`
														}
														variant="outlined"
													/>
												)}
											</Box>
										</TableCell>
										<TableCell>{cmd.desc || str}</TableCell>
										<TableCell>
											{cmd.examples?.map((example: any) => (
												<>
													{example}
													<br />
												</>
											)) || str}
										</TableCell>
									</TableRow>
								))}
						</TableBody>
					</Table>
				</Box>
			</Box>
		</Fragment>
	);
};

export default Commands;
